<template>
    <div class="o-date-selector">
        <ADropdown
            v-model="localValue"
            :items="list"
            placement="bottom-start"
            name-field="value"
            key-field="value"
        />
    </div>
</template>

<script>
import ADropdown from '../../atoms/a-dropdown';

export default {
    name: 'ODateSelector',
    components: {
        ADropdown
    },
    props: {
        list: {
            type: Array,
            default: () => []
        },
        value: {
            type: String,
            default: ''
        }
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(e) {
                this.$emit('input', e);
            }
        }
    }

}
</script>

<style lang="scss" src="./theme.scss" />
